export const SCENE_DEFAULT = {
  groupId: 'welcome',
  sceneId: 'tong-the-toan-canh',
};

export const SCENES_AUTO_PLAY = [
  'san-truoc',
  'sanh-tang-1',
  'phong-khach',
  'sanh-tang-2',
  'hanh-lang-truoc-phong-noc',
  'phong-noc',
  'hanh-lang-truoc-phong-server',
  'phong-pccc',
  'hanh-lang-truoc-phong-nguon',
  'phong-nguon-1',
  'phong-nguon-2',
  // 'phong-qjien-co',
  // 'phong-server-1',
  // 'phong-server-2-',
  // "phong-server-2rong",
  'ha-tang-phia-sau---tren-cao',
  'ha-tang-phia-sau',
  'ha-tang-phia-sau---trong',
  'hanh-lang-ben-phai',
  'tong-the-toan-canh',
];

export const SCENE_CHECK_PASSWORD = [
  {
    id: 'phong-qjien-co',
    level: 2,
  },
  {
    id: 'phong-server-1',
    level: 2,
  },
  {
    id: 'phong-server-2-',
    level: 2,
  },
  {
    id: 'phong-server-2---trong',
    level: 2,
  },
];

export const SCENE_TRANSCRIPTIONS = [
  {
    id: 'tong-the-toan-canh',
    text_vn:
      'Kính chào quý khách đã đến với phiên bản số của Trung tâm internet Việt Nam. Trung tâm Internet Việt Nam là đơn vị trực thuộc Bộ Thông tin và Truyền thông, với vai trò quan trọng trong việc quản lý và thúc đẩy sự phát triển của tài nguyên Internet tại Việt Nam. Trung tâm chịu trách nhiệm toàn diện từ đăng ký, duy trì, phân bổ đến thu hồi các tài nguyên internet. Đồng thời, chúng tôi cũng thiết lập, quản lý và vận hành Hệ thống DNS quốc gia và Trạm trung chuyển Internet quốc gia VNIX, đảm bảo hạ tầng mạng luôn hoạt động ổn định, hiệu quả và an toàn. Đây là nền tảng quan trọng cho sự phát triển không ngừng của Internet tại Việt Nam. Chúng ta bắt đầu chuyến tham quan từ cái nhìn tổng thể trên cao. Từ đây, quý vị có thể chiêm ngưỡng toàn bộ quy mô của Trung tâm Internet Việt Nam với các tòa nhà chức năng hiện đại được bố trí hài hòa cùng hệ thống hạ tầng tiên tiến.',
    text_en:
      'Welcome to the digital version of the Vietnam Internet Center. The Vietnam Internet Center is an entity under the Ministry of Information and Communications, playing a vital role in managing and promoting the development of Internet resources in Vietnam. The center is fully responsible for the registration, maintenance, allocation, and withdrawal of Internet resources. Additionally, we establish, manage, and operate the National DNS System and the VNIX National Internet Exchange, ensuring that the network infrastructure operates stably, efficiently, and securely. This forms a critical foundation for the continuous development of the Internet in Vietnam. Let us begin the tour with an aerial overview. From here, you can admire the entire scale of the Vietnam Internet Center, featuring modern functional buildings harmoniously arranged alongside advanced infrastructure systems.',
  },
  {
    id: 'san-truoc',
    text_vn:
      'Tiến về phía trước trung tâm, quý vị sẽ thấy khu vực mặt tiền được thiết kế với phong cách hiện đại, kết hợp không gian xanh thân thiện, tạo nên một ấn tượng chuyên nghiệp ngay từ khi bước chân vào.',
    text_en:
      'Moving forward to the front of the center, you will see a facade designed in a modern style, seamlessly blended with a green and friendly environment, creating a professional impression from the very first step.',
  },
  {
    id: 'sanh-tang-1',
    text_vn:
      'Tại sảnh chờ tầng 1, chúng tôi bố trí một không gian rộng rãi, thoải mái với các ghế ngồi tiện nghi và bảng thông tin điện tử, phục vụ khách đến thăm. Tiếp đó là phòng chờ tầng 1, nơi mang đến không gian yên tĩnh và mát mẻ, thích hợp cho các vị khách hoặc đối tác trong lúc chờ cuộc hẹn.',
    text_en:
      'In the first-floor lobby, we have arranged a spacious and comfortable area with convenient seating and electronic information boards to accommodate visitors. Adjacent to this is the first-floor waiting room, offering a quiet and cool space, ideal for guests or partners while they wait for their appointments.',
  },
  {
    id: 'phong-khach',
    text_vn:
      'Tiếp đó là phòng chờ tầng 1, nơi mang đến không gian yên tĩnh và mát mẻ, thích hợp cho các vị khách hoặc đối tác trong lúc chờ cuộc hẹn.',
    text_en:
      'Following this is the first-floor waiting room, which provides a quiet and cool space, ideal for guests or partners while waiting for their appointments.',
  },
  {
    id: 'sanh-tang-2',
    text_vn:
      'Mời quý vị di chuyển lên sảnh tầng 2, nơi được thiết kế hiện đại và chuyên nghiệp, kết nối các khu vực quan trọng như phòng họp và các khu vực kỹ thuật.',
    text_en:
      'Please proceed to the second-floor lobby, designed with modernity and professionalism, connecting key areas such as meeting rooms and technical zones.',
  },
  {
    id: 'hanh-lang-truoc-phong-noc',
    text_vn:
      'Khi đi qua hành lang khu vực NOC và phòng điện cơ, quý vị sẽ tiếp cận phòng NOC – trung tâm điều hành mạng, nơi đội ngũ chuyên gia giám sát hệ thống qua các thiết bị và màn hình hiện đại. Cạnh đó là phòng điện cơ, đảm nhận việc vận hành và bảo trì hệ thống điện, đảm bảo hoạt động ổn định cho trung tâm.',
    text_en:
      'As you walk through the hallway of the NOC area and the electromechanical room, you will arrive at the NOC room – the Network Operations Center, where a team of experts monitors the system using advanced equipment and screens. Adjacent to it is the electromechanical room, responsible for operating and maintaining the electrical system, ensuring stable operations for the center.',
  },
  {
    id: 'phong-noc',
    text_vn:
      'Phòng NOC – hay còn gọi là Trung tâm Điều hành – là trái tim của toàn bộ hệ thống tại Trung tâm Internet Việt Nam. Đây là nơi đội ngũ chuyên gia giám sát và quản lý mọi hoạt động mạng 24/7, đảm bảo sự ổn định, an toàn và hiệu quả cho các kết nối internet. Phòng được trang bị các màn hình hiển thị lớn, cho phép theo dõi thời gian thực tất cả các thông số kỹ thuật và tình trạng mạng.',
    text_en:
      'The NOC room – also known as the Network Operations Center – is the heart of the entire system at the Vietnam Internet Center. This is where a team of experts monitors and manages all network activities 24/7, ensuring stability, security, and efficiency for internet connections. The room is equipped with large display screens, enabling real-time monitoring of all technical parameters and network status.',
  },
  {
    id: 'phong-pccc',
    text_vn:
      'Phòng PCCC là trung tâm kiểm soát an toàn cháy nổ của Trung tâm Internet Việt Nam, được thiết kế để bảo vệ con người, tài sản và hệ thống hạ tầng. Phòng được lắp đặt các thiết bị hiện đại như hệ thống báo cháy tự động, hệ thống chữa cháy khí và thiết bị giám sát toàn diện. Tại đây, đội ngũ kỹ thuật viên chịu trách nhiệm kiểm tra, bảo dưỡng thường xuyên để đảm bảo mọi hệ thống hoạt động hiệu quả trong mọi tình huống. Phòng PCCC đóng vai trò quan trọng trong việc bảo vệ an toàn và đảm bảo sự vận hành liên tục, ổn định của trung tâm.',
    text_en:
      'The Fire Prevention and Fighting (FPP) room serves as the safety control center for fire prevention at the Vietnam Internet Center, designed to protect people, assets, and infrastructure systems. The room is equipped with state-of-the-art devices such as an automatic fire alarm system, gas-based fire suppression systems, and comprehensive monitoring equipment. Here, a team of technicians is responsible for regular inspections and maintenance to ensure all systems operate effectively in any situation. The FPP room plays a crucial role in safeguarding safety and ensuring the continuous and stable operation of the center.',
  },
  {
    id: 'phong-qjien-co',
    text_vn:
      'Phòng điện cơ là khu vực đóng vai trò then chốt trong việc đảm bảo hoạt động ổn định và liên tục cho toàn bộ hệ thống tại Trung tâm Internet Việt Nam. Đây là nơi đặt các thiết bị điện và cơ khí hiện đại, chịu trách nhiệm cung cấp và phân phối nguồn năng lượng cho mọi khu vực trong trung tâm. Phòng được thiết kế với tiêu chuẩn cao về an toàn và hiệu quả, tích hợp hệ thống giám sát tự động để theo dõi và quản lý tải điện. Ngoài ra, đội ngũ kỹ thuật viên luôn sẵn sàng vận hành và bảo trì thiết bị nhằm đảm bảo rằng mọi hoạt động từ nhỏ nhất đến quan trọng nhất đều diễn ra trơn tru, không gián đoạn.',
    text_en:
      'The Electromechanical Room plays a pivotal role in ensuring the stable and uninterrupted operation of the entire system at the Vietnam Internet Center. This is where modern electrical and mechanical equipment is housed, responsible for supplying and distributing energy to every area of the center. The room is designed to meet high standards of safety and efficiency, featuring an integrated automatic monitoring system to oversee and manage electrical loads. Additionally, a team of technicians is always on standby to operate and maintain the equipment, ensuring that all activities, from the smallest tasks to the most critical operations, run smoothly without interruption.',
  },
  {
    id: 'hanh-lang-truoc-phong-server',
    text_vn:
      'Tiến đến khu vực phòng Server, quý vị sẽ đi qua hành lang dẫn đến phòng Server 1 và phòng Server 2. Đây là nơi vận hành và lưu trữ các máy chủ quan trọng với hệ thống kiểm soát môi trường tiên tiến, đảm bảo dịch vụ luôn ổn định và bảo mật cao.',
    text_en:
      'Moving to the Server Room area, you will pass through the hallway leading to Server Room 1 and Server Room 2. These rooms house and operate critical servers, equipped with advanced environmental control systems to ensure stable services and high security.',
  },
  {
    id: 'phong-server-1',
    text_vn:
      'Đây là khu vực lưu trữ và vận hành các máy chủ quan trọng, được trang bị hệ thống kiểm soát môi trường tiên tiến nhằm đảm bảo điều kiện hoạt động tối ưu. Tất cả các thiết bị tại đây đều được quản lý và giám sát chặt chẽ để duy trì hiệu suất và độ ổn định cao nhất.',
    text_en:
      'This area is dedicated to storing and operating critical servers, equipped with advanced environmental control systems to ensure optimal operating conditions. All equipment here is closely managed and monitored to maintain the highest performance and stability.',
  },
  {
    id: 'phong-server-2-',
    text_vn:
      'Phòng Server 2 được thiết kế để hoạt động song song và bổ trợ cho Phòng Server 1, nhằm đảm bảo tính liên tục trong vận hành. Với hệ thống bảo mật và kiểm soát hiện đại, phòng này đóng vai trò quan trọng trong việc cung cấp dịch vụ mạng an toàn và ổn định.',
    text_en:
      'Server Room 2 is designed to operate in parallel and complement Server Room 1, ensuring continuous operation. With modern security and control systems, this room plays a crucial role in providing secure and stable network services.',
  },
  {
    id: 'phong-server-2---trong',
    text_vn:
      'Phòng Server 2 được thiết kế để hoạt động song song và bổ trợ cho Phòng Server 1, nhằm đảm bảo tính liên tục trong vận hành. Với hệ thống bảo mật và kiểm soát hiện đại, phòng này đóng vai trò quan trọng trong việc cung cấp dịch vụ mạng an toàn và ổn định.',
    text_en:
      'Server Room 2 is designed to operate in parallel and complement Server Room 1, ensuring continuous operation. With modern security and control systems, this room plays a crucial role in providing secure and stable network services.',
  },
  {
    id: 'hanh-lang-truoc-phong-nguon',
    text_vn:
      'Di chuyển tiếp qua hành lang trước phòng nguồn, chúng ta sẽ ghé thăm phòng nguồn 1 và phòng nguồn 2, nơi cung cấp và dự phòng nguồn điện, đảm bảo hệ thống vận hành liên tục, không gián đoạn.',
    text_en:
      'Continuing through the hallway in front of the power room, we will visit Power Room 1 and Power Room 2, where power is supplied and backed up, ensuring continuous, uninterrupted system operation.',
  },
  {
    id: 'phong-nguon-1',
    text_vn:
      'Phòng nguồn 1 đảm nhận vai trò quan trọng trong việc cung cấp điện năng ổn định và liên tục cho toàn bộ hệ thống. Được trang bị các công nghệ giám sát hiện đại, phòng này giúp theo dõi và điều chỉnh nguồn cung cấp điện để đảm bảo mọi hoạt động của trung tâm không bị gián đoạn.',
    text_en:
      'Power Room 1 plays a crucial role in providing stable and continuous power to the entire system. Equipped with advanced monitoring technologies, this room helps track and adjust the power supply to ensure that all operations of the center run without interruption.',
  },
  {
    id: 'phong-nguon-2',
    text_vn:
      'Phòng nguồn 2 hỗ trợ việc cung cấp điện dự phòng và phân phối tải điện, đảm bảo sự vận hành liên tục của hệ thống. Với chức năng này, phòng giúp trung tâm duy trì hoạt động ổn định ngay cả trong những tình huống cần phải chuyển đổi nguồn điện hoặc gặp sự cố về nguồn cung cấp.',
    text_en:
      'Power Room 2 supports backup power supply and load distribution, ensuring the continuous operation of the system. With this function, the room helps the center maintain stable operations even in situations that require switching power sources or when there are issues with the power supply.',
  },
  {
    id: 'ha-tang-phia-sau---trong',
    text_vn:
      'Khu vực kỹ thuật điện là nơi kiểm soát và cung cấp nguồn năng lượng cho toàn bộ hệ thống tại Trung tâm Internet Việt Nam. Đây là nơi đặt các thiết bị điện quan trọng.',
    text_en:
      'The electrical technical area is where the power supply for the entire system at the Vietnam Internet Center is controlled and provided. This is where important electrical equipment is located.',
  },
  {
    id: 'hanh-lang-ben-phai',
    text_vn:
      'Lối đi bên phải tòa nhà dẫn ra khu vực công viên và bãi đỗ xe, một không gian xanh mát và thoải mái, mang lại sự tiện nghi cho nhân viên và khách đến thăm. Khu vực này được thiết kế với không gian rộng rãi, thoáng đãng.',
    text_en:
      'The walkway on the right side of the building leads to the park and parking area, a refreshing and comfortable green space that provides convenience for both staff and visitors. This area is designed with spacious and airy surroundings.',
  },
];

export const COLOR_BAR_CHART = [
  '#F96D6F',
  '#8BA4FA',
  '#F5B77B',
  '#F2B25B',
  '#5C77D6',
  '#7C99FD',
];
